import React, { useState, useEffect, useRef } from "react";
import { getSiteSpaces, getSiteBuildings, getBuildingFloors, getZoneSpaces, getBuildingSpaces, updateSpace } from '../../services/MetadataService';
import { getBrickSpaceTypes, getPNNLSpaceTypes } from '../../services/DimensionsServices';
import SpaceList from "../../components/SpaceList";

const LoadedSpaceList = (props) => {
    const [spaces, setSpaces] = useState(props.spaces)
    const [buildings, setBuildings] = useState()
    const [floors, setFloors] = useState()
    const [brickTypes, setBrickTypes] = useState()
    const [pnnlTypes, setPnnlTypes] = useState()
    const prevSite = useRef(props.siteId).current;

    useEffect(() => {
        if (!spaces) {
            if (props.zoneId) {
                getZoneSpaces(props.zoneId).then((response) => {
                    setSpaces(response);
                });
            } else if (props.buildingId) {
                getBuildingSpaces(props.buildingId).then(response => {
                    setSpaces(response)
                });
            } else if (props.siteId) {
                getSiteSpaces(props.siteId).then(response => {
                    setSpaces(response)
                });
            } 
    
        }

        if (props.buildingId) {
            getBuildingFloors(props.buildingId).then(floors => {
                setFloors(floors)
            })
        }

        getBrickSpaceTypes().then(types => {
            setBrickTypes(types)
        })

        getPNNLSpaceTypes().then(types => {
            setPnnlTypes(types)
        })
    },[])

    useEffect(() => {
        
        if (props.siteId && prevSite != props.siteId) {
            getSiteBuildings(props.siteId).then(buildings => {
                setBuildings(buildings)
            })
            
            if (!spaces) {
                getSiteSpaces(props.siteId).then(response => {
                    setSpaces(response)
                });
            }

        }
    }, [props.siteId])

    const submitChanges = async (space) => {
        console.log("Submitting update to space:")
        console.log(space)
        updateSpace(space).then(response => {
            if (props.zoneId) {
                getZoneSpaces(props.zoneId).then((response) => {
                    setSpaces(response);
                });
            } else if (props.buildingId) {
                getBuildingSpaces(props.buildingId).then(response => {
                    setSpaces(response)
                });
            } else if (props.siteId) {
                getSiteSpaces(props.siteId).then(response => {
                    setSpaces(response)
                });
            } 
        })
    }

    return(
        <SpaceList 
            spaces={spaces} 
            siteId={props.siteId} 
            buildingId={props.buildingId}
            buildings={buildings}
            floors={floors}
            brickTypes={brickTypes}
            pnnlTypes={pnnlTypes}
            getFloors={getBuildingFloors}
            removeFromZoneCallback={props.removeFromZone} 
            addToZoneCallback={props.addToZone} 
            allSpaces={props.siteSpaces}
            spaceAddRoute={props.spaceAddRoute}
            updateSpace={submitChanges}
        />
    )
}

export default LoadedSpaceList;


